module.exports = __webpack_public_path__ + "img/black-rhino.ce60a898.png";